<template>
    <div @scroll="stickyNavigation">
        <a class="tone-skip-link" href="#main-content" @click="focusMain">Skip to main content</a>
        <div class="container-fluid" :class="{'unauth-header': !user}" v-bind:style="{  backgroundColor: getCorpHeaderColor +' !important'}">
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <ToneHeader class="gradient-tone-header"  :hide-nav="hideNav" v-bind:style="{ backgroundColor: getCorpHeaderColor +' !important'}"></ToneHeader>
                    </div>
                </div>
            </div>
        </div>

        <main id="main-content" ref="mainContent" tabindex="-1" class="text-center min-body-height" aria-label="Main content">
            <transition name="slide-fade" @after-enter="onViewReady" @after-leave="onViewReady">
                <router-view></router-view>
            </transition>
        </main>
        <div class="sr-only" role="status" aria-live="polite" aria-atomic="true">{{accessibilityStatus}}</div>

        <div class="container-fluid" v-bind:style="{ backgroundColor: getCorpFooterColor}">
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <!-- ToneFooter  v-bind:style="{ backgroundColor: getCorpFooterColor}"></ToneFooter -->
                        <ToneFooter class="gradient-tone-header"></ToneFooter>
                    </div>
                </div>
            </div>
        </div>
    </div><!-- /.container -->
</template>

<script>
import Header from '@/components/layout/Header'
import Footer from '@/components/layout/Footer'
import {mapGetters} from 'vuex'
import { visible } from './accessibility/controls'
// import { dateHelpers } from './helpers/dateHelpers.js'

export default {
    name: 'app',
    metaInfo () {
        const name = this.$route.name || 'Home'
        const title = name === 'UnAuth' ? 'Home' : name.replace(/([a-z])([A-Z])/g, '$1 $2')
        // Existing child vue-meta titles override this fallback.
        return { title: 'TONE | ' + title }
    },
    components: {
        'ToneHeader': Header,
        'ToneFooter': Footer
    },
    data: function () {
        return {
            headerColor: '#f0617d',
            scrollPosition: 155,
            gTagCorporationId: 0,
            hideNav: this.$route.meta.hideNav,
            accessibilityStatus: '',
            pendingRouteFocus: false,
            html: {
                background: 'yellow !important'
            }
        }
    },
    mounted: function () {
        // Add Google Analytics script
        const script = document.createElement('script')
        script.async = true
        script.src = 'https://www.googletagmanager.com/gtag/js?id=G-8056SCPWK0'

        document.head.appendChild(script)

        console.log('in App.vue : user = ', this.user)
        if (this.user && this.user.corporation) { // corporate user, change list list of experts
            this.gTagCorporationId = this.user.corporation.corporationId
        }
        console.log('in App.vue : this.gTagCorporationId = ', this.gTagCorporationId)
        script.onload = () => {
            // Replace 'GA_MEASUREMENT_ID' with your actual GA4 measurement ID
            window.dataLayer = window.dataLayer || []
            function gtag () {
                window.dataLayer.push(arguments)
            }
            gtag('js', new Date())
            gtag('config', 'G-8056SCPWK0')
            gtag('gTagCorporationId', this.gTagCorporationId)
            gtag('event', 'CORPORATION', {
                'corporation_id': this.gTagCorporationId
            })
        }
    },
    watch: {
        '$store.getters.error': {
            deep: true,
            handler (error) {
                this.$nextTick(() => {
                    const message = error && error.show ? error.message : ''
                    const announced = message && this.$el && Array.prototype.some.call(this.$el.querySelectorAll('[role="alert"]'), alert => {
                        return visible(alert) && alert.textContent.indexOf(message) !== -1
                    })
                    this.accessibilityStatus = announced ? '' : message
                })
            }
        },
        '$route' (to, from) {
            this.hideNav = to.meta.hideNav ? to.meta.hideNav : false
            // Filtering/query changes retain focus; new route content receives focus.
            if (to.path !== from.path) {
                this.pendingRouteFocus = true
                this.$nextTick(this.onViewReady)
            }
        }
    },
    created () {
        window.addEventListener('scroll', this.stickyNavigation)
        // setTimeout(() => {
        //     this.setHeaderColor()
        // }, 3000)
        // TODO: delete below all lines after verify use case
//        let nextDate = new Date('2018-03-15')
//        console.log('is enabled', dateHelpers.dstEnabled(new Date()))
//        console.log('is enabled 2', dateHelpers.dstEnabled(new Date('2018-03-13')))
//        console.log(dateHelpers.dstEnabled(new Date()))
//        console.log(dateHelpers.getDatesDifference(nextDate, new Date())) // by default return Days
        // console.log(dateHelpers.getDatesDifference(nextDate, new Date(), minutes)) // example to get minutes
    },
    destroyed () {
        window.removeEventListener('scroll', this.stickyNavigation)
    },
    methods: {
        focusMain () {
            if (this.$refs.mainContent) this.$refs.mainContent.focus()
        },
        onViewReady () {
            if (!this.pendingRouteFocus) return
            // Leave transitions can briefly retain the previous view.
            const view = this.$refs.mainContent
            if (!view || view.querySelector('.slide-fade-enter-active, .slide-fade-leave-active')) return
            this.pendingRouteFocus = false
            this.focusMain()
        },
        setHeaderColor () {
            let self = this
            let loggedUser = null
            if (localStorage.getItem('loggedUser')) {
                loggedUser = JSON.parse(localStorage.getItem('loggedUser'))
            }
            if (loggedUser) { // Logged In User
                if (loggedUser && loggedUser.corporation && loggedUser.corporation.groupDefinitions && loggedUser.corporation.groupDefinitions.headerColor) {
                    self.headerColor = loggedUser.corporation.groupDefinitions.headerColor
                }
            } else { // Unauth User
                if (!loggedUser) { // User is not logge in, check if corp has custom theme
                    if (localStorage.getItem('corporateClientObject')) {
                        let corpObject = JSON.parse(localStorage.getItem('corporateClientObject'))
                        if (corpObject && corpObject.groupDefinitions && corpObject.groupDefinitions.headerColor) {
                            self.headerColor = corpObject.groupDefinitions.headerColor
                            // state.corpHeaderColor = corpObject.corpgroupDefinitions.headerColor
                        }
                    }
                }
            }
            console.log('updated color in app', this.headerColor)
        },
        stickyNavigation (e) {
//            if (e.srcElement.scrollingElement) {
//                let currentScrollPosition = e.srcElement.scrollingElement.scrollTop
//                if (currentScrollPosition < this.scrollPosition) {
//                    this.$store.commit('setStickyNavigation', { value: false })
//                }
//                if (currentScrollPosition > this.scrollPosition) {
//                    this.$store.commit('setStickyNavigation', { value: true })
//                }
//            }
            /*
            * For IE-8
            */
//            if (document.documentElement.scrollTop > 100) {
//                let currentScrollPosition = document.documentElement.scrollTop
//                if (currentScrollPosition < this.scrollPosition) {
//                    this.$store.commit('setStickyNavigation', { value: false })
//                }
//                if (currentScrollPosition > this.scrollPosition) {
//                    this.$store.commit('setStickyNavigation', { value: true })
//                }
//            }
        }
    },
    computed: {
        ...mapGetters([
            'user', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor'
        ])
    }
}
</script>

<style lang="scss">
    @import '../src/scss/main.scss';
    @import '../src/scss/accessibility.scss';
    .gradient-tone-header {
        /* TT-1039- REBRANDING */
        background: linear-gradient(
                to right,
                #237d6e 0%,
                #237b79 30%,
                #23778a 60%,
                #004573 100%
        );
    }
    /*for vertical slide*/
    .scroll-fade-enter-active {
        transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .scroll-fade-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .scroll-fade-enter, .scroll-fade-leave-to
        /* .scroll-fade-leave-active for <2.1.8 */ {
        transform: translateY(10px);
        opacity: 0;
    }

    /*for horizontal slide*/
    .slide-fade-enter-active {
        transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for <2.1.8 */ {
        transform: translateX(10px);
        opacity: 0;
    }
</style>
<style>
    /*.modal {*/
    /*    z-index: 999999;*/
    /*}*/
    .min-body-height{min-height: calc(100vh - 557px);}

    .unauth-header a.giftslink {
        display: none;
    }

    .unauth-header .notificationtext {
        display: none;
    }

    .unauth-header header .logo {
        height: auto;
        margin: 0px;
        padding: 15px;
        width: auto;
        float: left;
    }

    .unauth-header header .nav-container {
        background: transparent;
        width: 85%;
    }
    .unauth-header li.mid-icons.sign-up-button {
        display: none;
    }

    .unauth-header div#header-navbar {}

    .unauth-header .nav-container {
        display: inline-block;
    }

    .unauth-header header .nav-container .container {
        width: 100%;
    }

    .unauth-header header .logo img {
        height: 62px;
    }

    .unauth-header header .nav-container .navbar .margin-left li a p {
        color: #fff;
    }

    .unauth-header header .nav-container .navbar .margin-left li a i {
        color: #fff !important;
        /*filter: brightness(100);*/
    }

    .unauth-header header .nav-container .navbar .margin-left li a img.aboutimg {
        display: none;
    }

    .unauth-header header .nav-container .navbar .margin-left li a img.aboutuswhite {
        display: inline;
        max-width: 30px;
        position: relative;
        top: -2px;
    }

    .unauth-header header .nav-container #header-navbar .navbar-right .login-btn a {
        color: #fff;
        font-size: 21px;
        height: auto;
        line-height: 1.3;
    }

    .unauth-header header .nav-container #header-navbar .navbar-right li.mid-icons a i {
        color: #fff;
        /*filter: brightness(100);*/
        padding: 10px;
    }

    .unauth-header .nav > li > a:hover, .nav > li > a:focus {
        background: rgba(0,0,0,0.1);
    }
    @media(min-width:1200px) and (max-width:1280px){
        header .nav-container a {
            padding: 23px 4px 12px 4px;
        }
    }
    @media(min-width:981px) and (max-width:1300px){
        body .unauth-header header .nav-container {
            width: calc(100% - 185px);
        }
    }
    @media(max-width:1030px) and (min-width:981px) {
        header .nav-container #header-navbar .navbar-right .login-btn a {
            padding: 8px 5px !important;
        }
        body header .nav-container #header-navbar .navbar-right li.mid-icons {
            margin: 0 3px;
        }
    }
    @media(min-width:768px) and (max-width:980px){
        body .unauth-header header .nav-container {
            width: calc(100% - 130px);
        }
        .unauth-header header .logo img{
            width:100px;
        }
        body header .nav-container #header-navbar .navbar-right .login-btn a {
            padding: 8px 2px !important;
        }
    }

    @media(max-width:767px){



        .unauth-header header .nav-container {
            margin: auto;
            display: block;
            width: auto;
        }

        .unauth-header header .nav-container .navbar svg {
            width: auto;
            margin: 0;
            display: block;
            float: left;
            position: static;
        }

        .unauth-header header .nav-container .mobile-loginLogoutholder a.btn.btn-link {
            line-height: 1.3;
            font-size: 21px;
            padding: 10px;
            border: 1px solid #fff;
            border-radius: 5px;
            float: right;
            margin: 2px 10px;
        }

        .unauth-header header .nav-container .mobile-loginLogoutholder {
            position: static;
        }

        .unauth-header header .nav-container nav.navbar.default-min-height {
            min-height: 73px !important;
            background: linear-gradient(
                to right,
                #237d6e 0%,
                #237b79 30%,
                #23778a 60%,
                #004573 100%
            );
        }

        .unauth-header header .nav-container #header-navbar .navbar-left li {
            background: #fff;
        }

        .unauth-header header .nav-container #header-navbar .navbar-left li a p {
            color: #000;
        }

        .unauth-header header .nav-container #header-navbar .navbar-left li a i ,
        .unauth-header header .nav-container #header-navbar .navbar-left li a i:before{
            color: #777 !important;
            filter: brightness(1) !important;
        }

        .unauth-header header .nav-container #header-navbar .navbar-left li a {
            margin: 0 70px;
        }
        .unauth-header header .nav-container .navbar .margin-left li a img.aboutuswhite {display: none;}

        .unauth-header header .nav-container .navbar .margin-left li a img.aboutimg {
            display: inline-block;
        }
        .unauth-header header .nav-container #header-navbar .navbar-left li a.router-link-active:before{
            background: transparent !important;
        }
        .unauth-header header .nav-container #header-navbar .margin-minimum{display:none !important}
        div.tabContent {
            padding: 0 15px;
        }
    }
    @media (max-width:374px){
        .unauth-header header .nav-container .navbar svg {
            width: 110px;
        }

        .unauth-header header .nav-container .mobile-loginLogoutholder a.btn.btn-link {
            padding: 8px 5px;
            margin: 0;
        }
    }

    .bodyfont-unauth,
    .bodyfont-unauth p,
    .bodyfont-unauth ul,
    .bodyfont-unauth li,
    .bodyfont-unauth a,
    .bodyfont-unauth div,
    .bodyfont-unauth h1,
    .bodyfont-unauth h2,
    .bodyfont-unauth h3,
    .bodyfont-unauth h4,
    .bodyfont-unauth h5,
    .bodyfont-unauth h6 {
        font-family: 'Zilla Slab', serif !important;
    }


    .bodyfont-unauth a,
    .bodyfont-unauth button,
    .bodyfont-unauth submit {
        font-family: 'Montserrat', sans-serif !important;
    }

    .bodyfont-unauth h1 a,
    .bodyfont-unauth h2 a,
    .bodyfont-unauth h3 a,
    .bodyfont-unauth h4 a,
    .bodyfont-unauth h5 a,
    .bodyfont-unauth h6 a {
        font-family: 'Zilla Slab', serif !important;
    }



</style>



// WEBPACK FOOTER //
// App.vue?6726b505